import { Box, TextField } from '@mui/material';
import MaterialTable from 'material-table';
import React from 'react';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import { useSelector, useDispatch } from 'react-redux';
import { UpsertOptionalHolidayCalendarAction, DeleteOptionalHolidayCalendarAction } from '../../../../../store/Leave/OptionalHolidayCalendar/Action';
import CommonDatePicker from '../../../Base/views/CommonDatePicker';
import { DateConvertInDbFormat } from '../../../Base/helper/baseFunctions';


const OptionalHolidayCalendar = () => {

    const dispatch = useDispatch();
    const { optionalHolidayData, isLoading } = useSelector(state => state.LeaveReducer?.OptionalHolidayCalendarReducer) || { optionalHolidayData: [] };

    return (
        <>
            <Box>
                <MaterialTable
                    key={optionalHolidayData?.map(item => item.optional_holidaycalendar_pk).join(',')}
                    isLoading={isLoading}
                    columns={[
                        {
                            title: "Holiday Name", cellStyle: { padding: "10px 5px" }, field: "name",
                            validate: (rowData) => {
                            if (rowData?.tableData && rowData?.tableData?.editing === "delete") {
                                return ""; 
                            }
                            if (!rowData?.name?.trim()) {
                                return "Name cannot be empty";
                            }
                            return "";
                            }, 
                            editComponent: props => (
                                <TextField
                                    required={true}
                                    variant="standard"
                                    value={props?.value}
                                    onChange={e => props.onChange(e.target.value)}
                                />
                            )
                        },
                        {
                            title: "Date", cellStyle: { padding: "10px 15px", }, field: "date", 
                            initialEditValue: DateConvertInDbFormat(),
                            validate: (rowData) => {
                            if (rowData?.tableData && rowData?.tableData?.editing === "delete") {
                                return ""; 
                            }
                            if (!rowData?.date) {
                                return "Date cannot be empty";
                            }
                            return "";
                            },
                            editComponent: props => {
                                return (
                                    <CommonDatePicker
                                        size="small"
                                        variant="standard"
                                        name="date"
                                        pickerType="date"
                                        onKeyPress={(e) => e.preventDefault()}
                                        onKeyDown={(e) => e.preventDefault()}
                                        pickerFormat="dd/MM/yyyy"
                                        DefaultDTvalue={props?.value || DateConvertInDbFormat()}
                                        handleChange={(value) => props.onChange(`${value?.getFullYear() + '-' + ("0" + (value.getMonth() + 1)).slice(-2) + '-' + ("0" + value.getDate()).slice(-2)}`)}
                                    />
                                )
                            },
                        },
                        {
                            title: "Description", cellStyle: { padding: "10px 5px" }, field: "description",
                            editComponent: props => (
                                <TextField
                                    variant="standard"
                                    value={props?.value || ""}
                                    onChange={e => props.onChange(e.target.value)}
                                />
                            )
                        },
                    ]}
                    data={optionalHolidayData || []}
                    icons={{
                        Add: () => <AddIcon />,
                        Edit: () => <EditIcon />,
                        Delete: () => <DeleteIcon />
                    }}
                    editable={{
                        onRowAdd: (newRow) =>
                            new Promise((resolve, reject) => {
                                if (!newRow?.name?.trim() || !newRow?.date) {
                                    return reject();
                                }
                                dispatch(UpsertOptionalHolidayCalendarAction({ ...newRow, optional_holidaycalendar_pk: null }))
                                setTimeout(() => resolve(), 500);
                            }),
                        onRowUpdate: (newRow, oldRow) =>
                            new Promise((resolve, reject) => {
                                if (!newRow?.name?.trim() || !newRow?.date) {
                                    return reject();
                                }
                                dispatch(UpsertOptionalHolidayCalendarAction(newRow))
                                setTimeout(() => resolve(), 500);
                            }),
                        onRowDelete: (selectedRow) =>
                            new Promise((resolve, reject) => {
                                dispatch(DeleteOptionalHolidayCalendarAction({ 
                                    ...selectedRow, 
                                    optional_holidaycalendar_ids: `{${selectedRow?.optional_holidaycalendar_pk}}`,
                                    year: new Date(selectedRow?.date).getFullYear()
                                }))
                                setTimeout(() => resolve(), 1000);
                            }),
                    }}
                    options={{
                        maxBodyHeight: 220,
                        rowStyle: { fontSize: "13px" },
                        headerStyle: { padding: "0px 10px", fontWeight: "bold" },
                        sorting: true,
                        search: false,
                        searchFieldAlignment: "right",
                        searchAutoFocus: true,
                        searchFieldVariant: "standard",
                        filtering: false,
                        paging: false,
                        selection: false,
                        actionsColumnIndex: -1,
                        grouping: false,
                        addRowPosition: "first",
                    }}
                    title=""
                />
            </Box>
        </>
    );
}

export default OptionalHolidayCalendar;
